<template>
  <div id="added_model" class="modal fade" tabindex="-1" role="dialog">
    <div class="modal-dialog modal-dialog-centered mx-auto" role="document">
      <div class="modal-content closefriend-modal">
        <button type="button" class="close text-white" data-dismiss="modal" @click="$emit('cancel')" style="position: absolute; right: 20px; top: 15px; z-index: 10; opacity: 0.7; text-shadow: none; outline: none;">
          <span aria-hidden="true" style="font-size: 28px;">&times;</span>
        </button>
        <div class="modal-body text-center">
          <h4 class="pt-3 font-size-24">Close Friend <span class="text-success">{{title}}</span></h4>
          <p class="pt-3 pb-3">{{ text }}</p>
          <div class="d-flex flex-row justify-content-center px-4 pb-4 mt-3">
            <button type="button" class="btn font-weight-500 rounded-pill stella-btn gradient-a text-white px-4 py-2"
                    @click="$emit('confirm')">Confirm
            </button>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Model",
  data() {
    return {
      title: '',
      text: ''
    }
  },
  methods: {
    cancel() {

    },
    show(title, text) {
      this.title = title;
      this.text = text;
      $('#added_model').modal();
    },
    hide() {
      $('#added_model').modal('toggle');
    }
  }
}
</script>

<style scoped>
.modal-dialog {
  max-width: 420px;
  margin: 1.5rem auto;
  width: calc(100% - 32px);
}

.modal-content.closefriend-modal {
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 24px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.5);
  overflow: hidden;
}
</style>


